module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/Location-f47306711baaf620069567f86dc93a6b.jpg";